import {
  $createTableCellNode,
  $createTableNode,
  $createTableRowNode,
  TableCellHeaderStates,
  TableNode,
} from "@lexical/table"
import { $createParagraphNode } from "lexical"
import { $convertFromMarkdownString, TEXT_FORMAT_TRANSFORMERS } from "@lexical/markdown"

export function createLexicalTableFromData(
  headers: string[],
  rows: string[][]
): TableNode | null {
  if (headers.length === 0) {
    return null
  }

  const tableNode = $createTableNode()

  // Create header row
  const headerRow = $createTableRowNode()
  headers.forEach((headerText) => {
    const cell = $createTableCellNode(TableCellHeaderStates.COLUMN)
    const paragraph = $createParagraphNode()
    $convertFromMarkdownString(headerText, TEXT_FORMAT_TRANSFORMERS, paragraph)
    cell.append(paragraph)
    headerRow.append(cell)
  })
  tableNode.append(headerRow)

  // Create data rows
  rows.forEach((row) => {
    const tableRow = $createTableRowNode()
    for (let i = 0; i < headers.length; i++) {
      const cell = $createTableCellNode(TableCellHeaderStates.NO_STATUS)
      const paragraph = $createParagraphNode()
      const cellText = row[i] || ""
      $convertFromMarkdownString(cellText, TEXT_FORMAT_TRANSFORMERS, paragraph)
      cell.append(paragraph)
      tableRow.append(cell)
    }
    tableNode.append(tableRow)
  })

  return tableNode
}
